import * as React from 'react';
import {useEffect} from 'react';
import { useSelector,useDispatch } from 'react-redux';

function TotalRecordBox()
{
    const state=useSelector((state)=>state);
    //const dispatch = useDispatch();

    const [selectedType, setSelectedType] = React.useState('A'); // 기본값 A
    
    useEffect(() => {
        window.GetNewSmallRoad = () => {
            var failCount = state.record_array[18].visual_continue_fail_count;
            var prediction = state.record_array[selectedType === 'A' ? 18 : 17].visual_prediction;
    
            var prediction_1 = state.record_array[1].prediction;

            if(prediction === prediction_1)// && failCount === 1)
            {
                return true;
            }
    
            return false;
        }

        return () => {
            // 컴포넌트 언마운트 시 정리
            delete window.GetNewSmallRoad;
        };
    }, [state, selectedType]);

    function GetTotalWin()
    {
        var record = state.record_array[selectedType === 'A' ? 18 : 17];

        var total = '';;
        total +=  record.visual_total_win_count;
        total += "승, ";
        
        return total;
    }

    function GetTotalFail()
    {
        var record = state.record_array[selectedType === 'A' ? 18 : 17];

        var total = '';
        total += record.visual_total_fail_count;
        total += "패";
        
        return total;
    }

    function GetContinueMaxWin()
    {
        var record = state.record_array[selectedType === 'A' ? 18 : 17];

        var total = '';
        total +=  record.visual_max_continue_win_count;
        total += "승, "
        
        return total;
    }

    function GetContinueMaxFail()
    {
        var record = state.record_array[selectedType === 'A' ? 18 : 17];
        
        var total = '';
        total += record.visual_max_continue_fail_count;
        total += "패";
        
        return total;
    }

    function GetContinueWin()
    {
        var record = state.record_array[selectedType === 'A' ? 18 : 17];

        var total = '';
        total +=  record.visual_continue_win_count;
        total += "승, ";

        return total;
    }

    function GetContinueFail()
    {
        var record = state.record_array[selectedType === 'A' ? 18 : 17];

        var total = '';
        total +=  record.visual_continue_fail_count;
        total += "패"

        return total;
    }


    function GetBackGroundColor()
    {
        return "RGB(255,255,255)";
        //var record = state.record_array[6];
        //if(record.continue_fail_count >= 5 )
        //{
        //    return "RGB(200,0,0)";
        //} 
        //else
        //{ 
        //    return "RGB(255,255,255)";
        //}
    }

    function GetHtml()
    {
        var failCount = state.record_array[18].visual_continue_fail_count;
        var prediction = state.record_array[selectedType === 'A' ? 18 : 17].visual_prediction;

        var prediction_2 = state.record_array[6].visual_prediction;
        var prediction_3 = state.record_array[3].prediction;

        var prediction_4 = state.record_array[1].prediction;
        
        if(prediction === "")
        {
            return <><span className="total-wating-value"><h2><p>{"WATING"}</p></h2></span></>
        }
        else if(prediction === "P")
        {
            return <><span className="total-blue-value"><h2 style={{ backgroundColor: prediction === prediction_4 ? 'red' : 'white' }}><p>{"PLAYER"}</p></h2></span></>
        }
        else if(prediction === "B")
        {
            return <><span className="total-red-value"><h2 style={{ backgroundColor: prediction === prediction_4 ? 'blue' : 'white'  }}><p>{"BANKER"}</p></h2></span></>
        }
        //else if(prediction === "P")
        //{
        //    return <><span className="total-blue-value"><h2 style={{ backgroundColor: prediction === prediction_4 && failCount === 1 ? 'red' : 'white' }}><p>{"PLAYER"}</p></h2></span></>
        //}
        //else if(prediction === "B")
        //{
        //    return <><span className="total-red-value"><h2 style={{ backgroundColor: prediction === prediction_4 && failCount === 1 ? 'blue' : 'white'  }}><p>{"BANKER"}</p></h2></span></>
        //}
        //else if(prediction === "P")
        //{
        //    return <><span className="total-blue-value"><h2 style={{ backgroundColor: 'white' }}><p>{"PLAYER"}</p></h2></span></>
        //}
        //else if(prediction === "B")
        //{
        //    return <><span className="total-red-value"><h2 style={{ backgroundColor: 'white'  }}><p>{"BANKER"}</p></h2></span></>
        //}
        //else if(prediction === "P")
        //{
        //    return <><span className="total-blue-value"><h2 style={{ backgroundColor: prediction === prediction_2 && record.out_break_type !== 2 ? 'red' : 'white' }}><p>{"PLAYER"}</p></h2></span></>
        //}
        //else if(prediction === "B")
        //{
        //    return <><span className="total-red-value"><h2 style={{ backgroundColor: prediction === prediction_2 && record.out_break_type !== 2 ? 'blue' : 'white'  }}><p>{"BANKER"}</p></h2></span></>
        //}
    }

    function GetHtml_OutBreak()
    {
        return <></>
        //var record = state.record_array[6];

        //if(record.out_break_type === 0)
        //{
        //    //<><div className="total-out-break-wait-type"></div></>
        //    return <></>
        //}
        //else if(record.out_break_type === 1)
        //{
        //    return <><div className="total-out-break-win-type"></div></>
        //}
        //else if(record.out_break_type === 2)
        //{
        //    return <><div className="total-out-break-fail-type"></div></>
        //}
    }

    function GetWinCount()
    {
        return state.record_array[selectedType === 'A' ? 18 : 17].win_fail_count;
    }

    function GetfailCount()
    {
        return state.record_array[selectedType === 'A' ? 18 : 17].fail_win_count;
    }

    function GetHtml_WinOutBreak()
    {
        return <></>
        var prediction = state.record_array[16].visual_prediction;
        var prediction_2 = state.record_array[3].prediction;
       
        var record = state.record_array[16];

        if(record.out_break_type === 0)
        {
            //<><div className="total-out-break-wait-type"></div></>
            return <></>
        }
        else if(record.out_break_type === 1)
        {
            if(prediction === prediction_2)
            {
                return <><div className="total-out-break-blue">A Type</div></>
            }   
            else
            {
                return <><div className="total-out-break-blue">B Type</div></>
            }
        }
    }

    function GetHtml_FailOutBreak()
    {
        return <></>
        var record = state.record_array[16];

        if(record.out_break_type === 0)
        {
            //<><div className="total-out-break-wait-type"></div></>
            return <></>
        }
        else if(record.out_break_type === 2)
        {
            return <><div className="total-out-break-red">C Type</div></>
        }
    }

    function GetBoxBackGroundColor(type)
    {
        var record;
        if(type == "D")
        {
            record = state.record_array[3];
        }
        else if(type == "E")
        {
            record = state.record_array[4];
        }
        else if(type == "F")
        {
            record = state.record_array[5];
        }

        if(record.out_break === true )
        {
            return "RGB(125,253,93)";
        } 
        else
        {
            return "RGB(255,255,255)";
        }
    }

    function GetBoxTieBackGroundColor(type)
    {
        return "RGB(255,255,255)";

        var record;
        if(type == "D")
        {
            record = state.record_array[3];
        }
        else if(type == "E")
        {
            record = state.record_array[4];
        }
        else if(type == "F")
        {
            record = state.record_array[5];
        }

        if(record.out_break === true )
        {
            return "RGB(35,127,12)";
        } 
        else
        {
            return "RGB(255,255,255)";
        }
    }

    const handleChange = (e) => {
        const value = e.target.value;
        setSelectedType(value);

        //dispatch({type:'UpdateSelType',SelectType:value});
    };
    
    return (        
        <div className='total-box' style={{backgroundColor:GetBackGroundColor()}}>
            <div className='total-prediction-value-box'>
                {GetHtml()}
                <div className='total-tie-value' style={{backgroundColor:GetBoxTieBackGroundColor("D")}}>T</div>
            </div>
            <div className='total-prediction-record-box-parent'>
                {GetHtml_OutBreak()}
                <div className='total-record-box'> 
                    <span className="total-total-value"><h2>전적</h2> <p><font color="blue">{GetTotalWin()}</font><font color="red">{GetTotalFail()}</font></p></span>
                    <span className="total-continue-win-value"><h2>최대</h2> <p><font color="blue">{GetContinueMaxWin()}</font><font color="red">{GetContinueMaxFail()}</font></p></span>
                    <span className="total-continue-fali-value"><h2>현재</h2> <p><font color="blue">{GetContinueWin()}</font><font color="red">{GetContinueFail()}</font></p></span>
                </div>
            </div>
            <div className='total-win-fail-box'>
                <div className='total-win-fail-box-chk'>
                    <label className='radioStyle radioStyle1'>
                        <input 
                        type="radio" 
                        name="chkType" 
                        value='A'
                        checked={selectedType === 'A'}
                        onChange={handleChange}/>
                        <span>
                            <div/>
                            <p>A type</p>
                        </span>
                    </label>
                </div>
                <div className='total-win-fail-box-chk'>
                    <label className='radioStyle radioStyle2'>
                        <input 
                        type="radio" 
                        name="chkType" 
                        value='B'
                        checked={selectedType === 'B'} 
                        onChange={handleChange} />
                        <span>
                            <div/>
                            <p>B type</p>
                        </span>
                    </label>
                </div>
            </div>

        </div>
    );
}

export default TotalRecordBox
